<template>
  <div class="content-wrapper-guide">
    <div class="guide-wrapper">
      <div
        class="guide-item-wrapper"
        v-for="(item, index) in homeIntroductions"
        :key="index"
        @click="handleClickOpenDialog(item)"
      >
        <div class="guide-item" style="">
          <div class="select-round"></div>
          <div
            class="border-wrapper"
            :style="{ 'background-color': item.color }"
          >
            <img :src="item.bgImage" :alt="item.title" />
          </div>
          <div class="title-wrapper">{{ item.title }}</div>
        </div>
      </div>
    </div>

    <el-dialog
      class="intro-dialog"
      :title="introForm.title"
      :visible.sync="introDialog"
      v-if="introDialog"
      center
      width="40%"
    >
      <div v-if="introForm.content" class="center">
        <p v-for="(item, index) in introForm.content" :key="index">
          {{ item }}
        </p>
      </div>
      <div v-else class="padding40">
        <div
          v-for="(item, index) in introForm.typeList"
          :key="index"
          class="type-item"
        >
          <h4 class="typeTitle">{{ item.typeName }}</h4>
          <div>
            <p
              class="textIdent"
              v-for="(content, index) in item.contents"
              :key="index"
            >
              {{ content }}
            </p>
          </div>
          <div class="typeImg-wrapper">
            <img
              class="typeImg"
              v-for="(src, index) in item.imgList"
              :key="index"
              :src="src"
            />
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="handleClickClose">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Vue, Component, Prop, Emit } from 'vue-property-decorator'
import { homeIntroductions } from '@src/constant/home'
@Component()
// 注意修改class名
export default class TrainerGuide extends Vue {
  @Prop(Object)
  data

  @Emit('dialog-show')
  postDialog() {}

  homeIntroductions = homeIntroductions
  line1 = homeIntroductions.slice(0, 2)
  line2 = homeIntroductions.slice(2)
  introForm = {}
  introDialog = false

  handleClickOpenDialog(item) {
    this.postDialog(item)
    console.log(this.item, '测试item')
    // this.introDialog = true
    // this.introForm = { ...item }
  }

  // handleClickClose() {
  //   this.introDialog = false
  // }
}
</script>

<style lang="scss" scoped>
.intro-dialog {
  .el-dialog__title {
    color: #ffa708;
  }
}

.content-wrapper-guide {
  width: 100%;
  height: 100%;
  padding: 0 12%;
  .guide-wrapper {
    transform: translateY(30%);
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100%;
    .guide-item-wrapper {
      width: 16.6vw;
      // height: 37vh;
      aspect-ratio: 0.8;
      .guide-item {
        color: #5c5c5c;
        position: relative;
        display: flex;
        flex-direction: column;
        background-color: white;
        border-radius: 5%;
        height: 100%;
        width: 100%;
        padding: 8.75% 0 0 0;
        .select-round {
          position: absolute;
          top: 3%;
          right: 3%;
          width: 6.25%;
          height: 5%;
          background-color: #ffa708;
          border-radius: 50%;
        }
        .border-wrapper {
          margin: 0 auto;
          height: 65%;
          width: 82%;
          padding: 20px;
          border-radius: 5%;
          img {
            display: block;
            width: 100%;
            height: 100%;
          }
        }
        .title-wrapper {
          display: flex;
          flex: 1;
          justify-content: center;
          align-items: center;

          font-size: 1.2rem;
        }
        &:hover {
          background-color: #ffa708;
          color: white;
          .select-round {
            background-color: white;
          }
        }
      }
    }
  }
}
</style>
